/* Visitor-only appearance preference. No catalog, cart or WhatsApp behavior is changed. */
(function () {
  'use strict';
  var root = document.documentElement;
  var key = 'indexes-color-mode';
  if (root.hasAttribute('data-ix-color-mode-ready')) return;
  root.setAttribute('data-ix-color-mode-ready', '');
  function apply(mode) {
    mode = mode === 'dark' ? 'dark' : 'light';
    root.setAttribute('data-ix-color-mode', mode);
    document.querySelectorAll('[data-ix-color-mode-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(mode === 'dark'));
      button.setAttribute('title', mode === 'dark' ? 'تفعيل الوضع الأبيض' : 'تفعيل الوضع الليلي');
      button.hidden = false;
    });
  }
  function restore() {
    var mode = root.getAttribute('data-ix-color-mode') || 'light';
    try { mode = localStorage.getItem(key) === 'dark' ? 'dark' : 'light'; } catch (e) {}
    apply(mode);
  }
  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('[data-ix-color-mode-toggle]');
    if (!button) return;
    var mode = root.getAttribute('data-ix-color-mode') === 'dark' ? 'light' : 'dark';
    apply(mode);
    try { localStorage.setItem(key, mode); } catch (e) { /* The current page still works when storage is unavailable. */ }
  });
  window.addEventListener('storage', function (event) {
    if (event.key === key || event.key === null) restore();
  });
  window.addEventListener('pageshow', restore);
  document.addEventListener('shopify:section:load', function () { apply(root.getAttribute('data-ix-color-mode')); });
  restore();
}());
